import React from 'react';
import './Modal.css'; // Optional: for basic styling

const Modal = ({ open, onClose, children }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay " >
      <div className="modal-box">
        <button className="modal-close-button" onClick={onClose}>X</button>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
